var lib_core = require("lib-core");
var ContentServerMetaData = require("../contentServerMetaData.js");

var CircuitMetaData = function (name) {
    ContentServerMetaData.call(this, name);
};
lib_core.inherit(CircuitMetaData, ContentServerMetaData);

module.exports = CircuitMetaData;

lib_core.JsonParser.registerClass(CircuitMetaData, "CircuitMetaData");

CircuitMetaData.prototype.initialize = function () {
    ContentServerMetaData.prototype.initialize.call(this);
};

CircuitMetaData.prototype.assetType = function () {
    return "circuits";
};

CircuitMetaData.prototype.assetPath = function () {
    return "circuits/";
};
